<!--选取参考模板 dialog-->
<template>
	<portal to="fix-temp">
		<div class="fix-temp-wrap">
			<div class="img-content"><img :src="fixTemp" alt="" /></div>
			<div class="img-ope">
				<el-button type="success" @click="heightIncrease">高度增加</el-button>
				<el-button type="primary" @click="heightDecrease">高度减少</el-button>
				<el-button type="success" @click="widthIncrease">宽度增加</el-button>
				<el-button type="primary" @click="widthDecrease">宽度减少</el-button>
			</div>
			<div class="img-ope">
				<el-button type="danger" style="width: 50%" @click.native="referQuit">取消</el-button>
				<el-button type="primary" style="width: 50%" @click="referConfirm">确认</el-button>
			</div>
		</div>
	</portal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { clipImage } from '../utils/js/clip'
import { cloneDeep } from 'lodash'

export default {
	name: 'fix-temp',
	data() {
		return {
			//模板
			fixTemp: '',
			//位置信息
			fixPos: {},
			//当前的答题卡
			curImg: ''
		}
	},
	watch: {
		//
		tempCurrentRefer: {
			handler(val) {
				this.fixPos = cloneDeep(val.pos)
				this.curImg = val.image
				this.fixTemp = val.base64Img
			},
			immediate: true,
			deep: true
		}
	},
	computed: {
		...mapGetters('examination/configation', ['tempCurrentRefer', 'tempReferRectList'])
	},
	mounted() {
		const _this = this
		document.onkeydown = function(event) {
			event.preventDefault()
			if (event.keyCode === 37) _this.widthIncrease()
			if (event.keyCode === 38) _this.heightIncrease()
			if (event.keyCode === 39) _this.widthDecrease()
			if (event.keyCode === 40) _this.heightDecrease()
		}
	},
	methods: {
		...mapActions('examination/databases', ['set', 'get']),
		...mapMutations('examination/configation', ['setTempCurrentRefer', 'setTempReferRectList']),
		// 取消
		referQuit() {
			this.setTempCurrentRefer({ base64Img: '', pos: {}, image: '' })
		},
		// 确定
		referConfirm() {
			this.referQuit()
			this.tempReferRectList.push({ image: this.fixTemp, pos: this.fixPos })
			this.setTempReferRectList(this.tempReferRectList)
		},

		// 宽度增加
		widthIncrease() {
			this.fixPos.startX += 1
			this.clip()
		},
		// 宽度减小
		widthDecrease() {
			this.fixPos.endX -= 1
			if (this.fixPos.endX <= 0) return false
			this.clip()
		},
		// 高度增加
		heightIncrease() {
			this.fixPos.startY += 1
			this.clip()
		},
		// 高度减少
		heightDecrease() {
			this.fixPos.endY -= 1
			if (this.fixPos.endY <= 0) return false
			this.clip()
		},
		//切图
		clip() {
			const _this = this
			clipImage(this.fixPos, this.curImg, image => {
				_this.fixTemp = image
			})
		}
	}
}
</script>

<style scoped lang="less">
.fix-temp-wrap {
	position: fixed;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: 450px;
	z-index: 10 !important;
	box-shadow: 0 0 15px #888888;
	background: white;
	border-radius: 10px;
	.img-content {
		height: 200px;
		padding: 20px;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			border: 1px solid red;
		}
	}
	.img-ope {
		padding: 0 20px;
		box-sizing: border-box;
		height: 60px;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
	}
}
</style>
